// extracted by mini-css-extract-plugin
export default {"select":"Sort_select__bWtFn","label":"Sort_label__XOKjm","container":"Sort_container__TAPgG"};